import { Alert } from '@mui/material';
import { SEP_PLAN_TAB_LABELS } from '../../shared/AppConstants';
import { useAppSelector } from '../../shared/hooks/reduxHooks';

export const NoSepPlansAlert = () => {
  const shouldDisplay = useAppSelector(
    (state) =>
      state.sepPlans.sepPlanCount === 0 &&
      state.sepPlans.isSepPlanError === false &&
      state.sepPlans.isSepPlanLoading === false
  );
  return (
    shouldDisplay && (
      <Alert
        variant="standard"
        sx={{ marginTop: '1rem', marginBottom: '1rem' }}
      >
        {SEP_PLAN_TAB_LABELS.NO_PLANS}
      </Alert>
    )
  );
};
